import axios from 'axios';

const API_ENDPOINT = 'https://world.openfoodfacts.org/api/v0/product/';

export async function fetchProductData(barcode) {
  try {
    const response = await axios.get(`${API_ENDPOINT}${barcode}.json`);

    // returning the response data from the API:
    return response.data;
  } catch (error) {
    console.error('Error fetching product data:', error);
    throw new Error('Failed to fetch product data');
  }
}
